module.exports = __webpack_public_path__ + "img/aacsb.9db01053.png";